// import { Button, Modal, Upload, message } from "antd";
// import React, { useEffect, useState } from "react";
// import {
//   ErrorToast,
//   ShowInputError,
//   SuccessToast,
// } from "../../../../widgets/AppToast";
// import AppInput from "../../../../components/AppInput";
// import { post } from "../../../../services/services";
// import { ApiURL } from "../../../../services/apiConstants";
// import SelectInput from "../../../../components/SelectInput";
// import moment from "moment";
// import useDocumentUpload from "../../../../hooks/useDocumentUpload";
// import { UploadOutlined } from "@ant-design/icons";
// import TextArea from "antd/es/input/TextArea";
// import { useNavigate } from "react-router-dom";

// function AddOliRecordLogPartOneModal({
//   visible,
//   onClose,
//   onSuccess,
//   parent_id,
// }) {
//   const navigate = useNavigate();
//   const [loader, set_loader] = useState(false);
//   const [errors, set_errors] = useState({});
//   const [staff_dashboard, set_staff_dashboard] = useState([]);
//   const [code, set_code] = useState("");
//   const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
//   const [signature, set_signature] = useState("");
//   const [codeList, setCodeList] = useState([]);
//   const [codeItemList, setCodeItemList] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [previous_log_date, set_Previous_Log_Date] = useState("");
//   const { documentList, handleDocumentChange, getFilesForUpload } =
//     useDocumentUpload();

//   const LIST_OIL_RECORD_CODE_API = () => {
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("orb_part", "1");
//     post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
//       if (res?.status === true) {
//         const newRespones = res?.code_categories?.map((item) => ({
//           value: item?.id,
//           label: `(${item?.value}) ${item?.label}`,
//         }));
//         LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
//         setCodeList(newRespones);
//         set_Previous_Log_Date(res?.last_record);
//       }
//     });
//   };

//   const LIST_OIL_RECORD_ITEM_API = (code_id) => {
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("code_category_id", code_id);
//     FORM_DATA.append("orb_part", "1");
//     post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
//       if (res?.status === true) {
//         const newRes = res?.subdetails?.map((item) => ({
//           value: item?.id,
//           label: item?.sub_code_name,
//           sub_code_name: item?.subdetails_child,
//         }));
//         setCodeItemList(newRes);
//       }
//     });
//   };

//   const ADD_OIL_RECORD_LOGBOOK_APIS = async () => {
//     const files = getFilesForUpload();
//     set_loader(true);
//     if (selectedItems?.some((item) => !item.value)) {
//       message.warning("All checked input should be filled");
//       set_loader(false);
//       return;
//     }
//     const FORM_DATA = new FormData();
//     FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
//     FORM_DATA.append("orb_part", "1");
//     FORM_DATA.append("code_category_id", code);
//     FORM_DATA.append("sub_detail_id", JSON.stringify(selectedItems));
//     FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
//     FORM_DATA.append("date", date);
//     FORM_DATA.append("operation_details", signature);
//     FORM_DATA.append("parent_id_for_I", parent_id);
//     files?.forEach((f) => FORM_DATA.append("files", f));

//     try {
//       const res = await post(ApiURL.add_orb_details_st, FORM_DATA);
//       if (res?.status) {
//         SuccessToast("Success", res?.message);
//         navigate("/list-oil-record-log-one");
//         set_loader(false);
//         onSuccess?.();
//         onClose();
//       } else {
//         ErrorToast("Error", res?.message);
//         set_errors(res?.response?.data?.errors || {});
//         set_loader(false);
//       }
//     } catch (error) {
//       ErrorToast("Error", "Something went wrong");
//       set_loader(false);
//     }
//   };

//   const groupedOptions = codeItemList.flatMap((item) => {
//     if (item.sub_code_name.length > 0) {
//       return {
//         label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
//         options: item.sub_code_name.map((sub, index) => ({
//           value: `${item.value}-${index}`,
//           label: ` ${sub?.subdetails_child}`,
//         })),
//       };
//     } else {
//       return {
//         value: item.value,
//         label: item.label,
//       };
//     }
//   });

//   const handleCheckboxChange = (value) => {
//     setSelectedItems((prevItems) => {
//       const exists = prevItems.find((item) => item.id === value);
//       return exists
//         ? prevItems.filter((item) => item.id !== value)
//         : [...prevItems, { id: value, value: "" }];
//     });
//   };

//   const handleInputChange = (id, value, key = "value") => {
//     setSelectedItems((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
//     );
//   };

//   useEffect(() => {
//     const data = localStorage.getItem("staff_dashboard");
//     if (data) {
//       set_staff_dashboard(JSON.parse(data));
//     }
//     LIST_OIL_RECORD_CODE_API();
//   }, []);

//   const getDocUrl = (file) => {
//     if (file.url) return file.url; // existing file
//     if (file.originFileObj) return URL.createObjectURL(file.originFileObj); // newly uploaded
//     return null;
//   };

//   const handlePreviews = async (file) => {
//     const url = getDocUrl(file);
//     if (!url) {
//       message.error("No preview available for this file");
//       return;
//     }
//     window.open(url, "_blank");
//   };

//   return (
//     <Modal
//       //   title="Add Oil Record Log - Part 1"
//       open={visible}
//       onCancel={onClose}
//       footer={[
//         <Button key="cancel" onClick={onClose}>
//           Cancel
//         </Button>,
//         <Button
//           key="save"
//           type="primary"
//           loading={loader}
//           onClick={ADD_OIL_RECORD_LOGBOOK_APIS}
//         >
//           Save
//         </Button>,
//       ]}
//       width={1000}
//     >
//       <div className="white-container">
//         <h3 style={{ color: "red", textAlign: "center" }}>
//           Missed Operation Details{" "}
//         </h3>
//         <br />
//         <h3>Oil Record book Part 1 Information</h3>
//         <br />
//         <div className="row">
//           <div className="col-6">
//             <SelectInput
//               label="Code"
//               value={code}
//               placeholder=" -- Selecte Code  -- "
//               style={{ width: "100%" }}
//               onChange={(value) => {
//                 set_code(value);
//                 setSelectedItems([]);
//                 LIST_OIL_RECORD_ITEM_API(value);
//               }}
//               options={codeList}
//               errors={errors?.code_category_id}
//             />
//           </div>
//           <div className="col-6">
//             <AppInput
//               type="date"
//               label="Date"
//               placeholder="Date"
//               value={date}
//               onChange={(e) => set_date(e.target.value)}
//               errors={errors.date}
//               showInfo={code !== 30}
//               infoMessage="Original Operation Date"
//               // min={previous_log_date}
//               max={new Date().toISOString().split("T")[0]}
//             />
//           </div>
//         </div>

//         {code && (
//           <div
//             className="col-12"
//             style={{
//               lineHeight: "2",
//               border: "1px solid #d9d9d9",
//               borderRadius: "5px",
//               marginBottom: "5px",
//             }}
//           >
//             <strong className="form-label">Select Items:</strong>
//             {groupedOptions.map((optionGroup, index) => (
//               <div key={index} className="mb-3">
//                 {/* Main Label as Checkbox */}
//                 <div className="row align-items-center mb-2">
//                   <div className="col-6">
//                     <div className="form-check">
//                       {optionGroup?.options?.length > 1 ? (
//                         ""
//                       ) : (
//                         <input
//                           className="form-check-input"
//                           type="checkbox"
//                           value={optionGroup.label}
//                           checked={selectedItems.some(
//                             (item) => item.id === optionGroup.value
//                           )}
//                           onChange={() =>
//                             handleCheckboxChange(optionGroup.value)
//                           }
//                           id={`group-checkbox-${index}`}
//                         />
//                       )}
//                       <label
//                         className="form-check-label"
//                         htmlFor={`group-checkbox-${index}`}
//                       >
//                         {typeof optionGroup.label === "string" ? (
//                           <strong>{optionGroup.label}</strong>
//                         ) : (
//                           <strong>{optionGroup.label.props.children}</strong>
//                         )}
//                       </label>
//                     </div>
//                   </div>

//                   {/* Input Field for Main Label */}
//                   <div className="col-6" style={{ marginLeft: "22px" }}>
//                     {selectedItems.some(
//                       (item) => item.id === optionGroup.value
//                     ) && (
//                       <TextArea
//                         required
//                         maxLength={1000}
//                         className="form-control"
//                         autoSize={{ minRows: 2 }}
//                         placeholder={
//                           typeof optionGroup.label === "string"
//                             ? optionGroup.label
//                             : optionGroup.label.props.children
//                         }
//                         value={
//                           selectedItems.find(
//                             (item) => item.id === optionGroup.value
//                           )?.value || ""
//                         }
//                         onChange={(e) =>
//                           handleInputChange(optionGroup.value, e.target.value)
//                         }
//                       />
//                     )}
//                   </div>
//                   {/* Special Input - Only for 112 */}
//                   {Number(optionGroup.value) === 112 && (
//                     <div className="col-6" style={{ marginBottom: 20 }}>
//                       {selectedItems.some(
//                         (item) => Number(item.id) === 112
//                       ) && (
//                         <TextArea
//                           required
//                           maxLength={1000}
//                           className="form-control"
//                           autoSize={{ minRows: 2 }}
//                           placeholder="Discharged Volume"
//                           value={
//                             selectedItems.find(
//                               (item) => Number(item.id) === 112
//                             )?.dischargedvolume || ""
//                           }
//                           onChange={(e) =>
//                             handleInputChange(
//                               112,
//                               e.target.value,
//                               "dischargedvolume"
//                             )
//                           }
//                         />
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 {/* Sub-options */}
//                 {optionGroup.options && (
//                   <div
//                     className="ms-3"
//                     style={{ marginLeft: "30px", padding: "10px" }}
//                   >
//                     {optionGroup.options.map((option) => (
//                       <div
//                         key={option.value}
//                         className="row align-items-center mb-2"
//                       >
//                         {/* Left Side - Checkbox */}
//                         <div className="col-6">
//                           <div className="form-check">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               value={option.value}
//                               checked={selectedItems.some(
//                                 (item) => item.id === option.value
//                               )}
//                               onChange={() =>
//                                 handleCheckboxChange(option.value)
//                               }
//                               id={`checkbox-${option.value}`}
//                             />
//                             <label
//                               className="form-check-label"
//                               htmlFor={`checkbox-${option.value}`}
//                             >
//                               {option.label}
//                             </label>
//                           </div>
//                         </div>

//                         {/* Right Side - Input Field */}
//                         <div className="col-6" style={{ padding: "5px" }}>
//                           {selectedItems.some(
//                             (item) => item.id === option.value
//                           ) && (
//                             <TextArea
//                               required
//                               maxLength={1000}
//                               className="form-control"
//                               autoSize={{ minRows: 2 }}
//                               placeholder={option.label}
//                               value={
//                                 selectedItems.find(
//                                   (item) => item.id === option.value
//                                 )?.value || ""
//                               }
//                               onChange={(e) =>
//                                 handleInputChange(option.value, e.target.value)
//                               }
//                             />
//                           )}
//                         </div>

//                         {/* Special case: two inputs only for id '111-3' and code '24' */}
//                         {option.value === "111-3" && (
//                           <div className="col-6" style={{ padding: "5px" }}>
//                             {selectedItems.some(
//                               (item) => item.id === option.value
//                             ) && (
//                               <TextArea
//                                 required
//                                 maxLength={1000}
//                                 className="form-control"
//                                 autoSize={{ minRows: 2 }}
//                                 placeholder={"Evaporation Volume"}
//                                 value={
//                                   selectedItems.find(
//                                     (item) => item.id === option.value
//                                   )?.evaporationVolume || "" // <- new JSON key
//                                 }
//                                 onChange={
//                                   (e) =>
//                                     handleInputChange(
//                                       option.value,
//                                       e.target.value,
//                                       "evaporationVolume"
//                                     ) // <- pass key name
//                                 }
//                               />
//                             )}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//         {errors.sub_detail_values && (
//           <ShowInputError errorMessage={errors.sub_detail_values} />
//         )}
//         <div className="row" style={{ alignItems: "center" }}>
//           <div className="col-6">
//             <AppInput
//               label="Name of operation incharge"
//               placeholder="Name of operation incharge"
//               value={signature}
//               onChange={(e) => set_signature(e.target.value)}
//               errors={errors.operation_details}
//               showInfo={code !== 30}
//               infoMessage="Signatur of In-charge (or C/E if signed off)"
//             />
//           </div>
//           <div className="col-6">
//             <div
//               className="input-box"
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "8px",
//                 alignItems: "flex-start",
//               }}
//             >
//               <label>Select File</label>
//               <Upload
//                 accept=".pdf,.doc,.docx,.xls,.xlsx"
//                 multiple
//                 fileList={documentList}
//                 onChange={handleDocumentChange}
//                 onPreview={handlePreviews}
//                 beforeUpload={() => false}
//                 listType="picture"
//               >
//                 <Button
//                   icon={<UploadOutlined />}
//                   type="primary"
//                   style={{
//                     borderRadius: "50%",
//                     padding: "10px",
//                     width: "40px",
//                     height: "40px",
//                     marginLeft: "10px",
//                   }}
//                 ></Button>
//               </Upload>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Modal>
//   );
// }

// export default AddOliRecordLogPartOneModal;




import { Button, Modal, Upload, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../../widgets/AppToast";
import AppInput from "../../../../components/AppInput";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SelectInput from "../../../../components/SelectInput";
import moment from "moment";
import useDocumentUpload from "../../../../hooks/useDocumentUpload";
import { UploadOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";

function AddOliRecordLogPartOneModal({
  visible,
  onClose,
  onSuccess,
  parent_id,
}) {
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [code, set_code] = useState("");
  const [date, set_date] = useState(moment().format("YYYY-MM-DD"));
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload();

  const LIST_OIL_RECORD_CODE_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("orb_part", "1");
    post(ApiURL.list_code_categories_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const newRespones = res?.code_categories?.map((item) => ({
          value: item?.id,
          label: `(${item?.value}) ${item?.label}`,
        }));
        LIST_OIL_RECORD_ITEM_API(newRespones?.[0]?.value);
        setCodeList(newRespones);
        set_Previous_Log_Date(res?.last_record);
      }
    });
  };

  const LIST_OIL_RECORD_ITEM_API = (code_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("code_category_id", code_id);
    FORM_DATA.append("orb_part", "1");
    post(ApiURL.list_subdetails_category_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const newRes = res?.subdetails?.map((item) => ({
          value: item?.id,
          label: item?.sub_code_name,
          sub_code_name: item?.subdetails_child,
        }));
        setCodeItemList(newRes);
      }
    });
  };

  const ADD_OIL_RECORD_LOGBOOK_APIS = async () => {
    const files = getFilesForUpload();
    set_loader(true);
    if (selectedItems?.some((item) => !item.value)) {
      message.warning("All checked input should be filled");
      set_loader(false);
      return;
    }
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
    FORM_DATA.append("orb_part", "1");
    FORM_DATA.append("code_category_id", code);
    FORM_DATA.append("sub_detail_id", JSON.stringify(selectedItems));
    FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
    FORM_DATA.append("date", date);
    FORM_DATA.append("operation_details", signature);
    FORM_DATA.append("parent_id_for_I", parent_id);
    files?.forEach((f) => FORM_DATA.append("files", f));

    try {
      const res = await post(ApiURL.add_orb_details_st, FORM_DATA);
      if (res?.status) {
        SuccessToast("Success", res?.message);
        navigate("/list-oil-record-log-one");
        set_loader(false);
        onSuccess?.();
        onClose();
      } else {
        ErrorToast("Error", res?.message);
        set_errors(res?.response?.data?.errors || {});
        set_loader(false);
      }
    } catch (error) {
      ErrorToast("Error", "Something went wrong");
      set_loader(false);
    }
  };

  const groupedOptions = codeItemList.flatMap((item) => {
    if (item.sub_code_name.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: item.sub_code_name.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: ` ${sub?.subdetails_child}`,
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label,
      };
    }
  });

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      return exists
        ? prevItems.filter((item) => item.id !== value)
        : [...prevItems, { id: value, value: "" }];
    });
  };

  const handleInputChange = (id, value, key = "value") => {
    setSelectedItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    );
  };

  const handleSpecialInputChange = (id, value, key = "specialValue") => {
  if (!/^[0-9A-Za-z.\s]*$/.test(value)) return; // Only allow alphanumeric + dot
  if (value.startsWith(".")) return; // No dot as first char
  if (value.length === 1 && !/^[0-9]$/.test(value)) return; // Must start with number
  if ((value.match(/\./g) || []).length > 1) return; // Only one dot allowed

  set_errors((prev) => ({ ...prev, [key]: "" }));

  setSelectedItems((prev) =>
    prev.map((item) =>
      item.id === id
        ? {
            ...item,
            [key]: value.toUpperCase(), 
            value: value.toUpperCase(), 
          }
        : item
    )
  );
};


  useEffect(() => {
    const data = localStorage.getItem("staff_dashboard");
    if (data) {
      set_staff_dashboard(JSON.parse(data));
    }
    LIST_OIL_RECORD_CODE_API();
  }, []);

  const getDocUrl = (file) => {
    if (file.url) return file.url; // existing file
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj); // newly uploaded
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };


  return (
    <Modal
      //   title="Add Oil Record Log - Part 1"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={loader}
          onClick={ADD_OIL_RECORD_LOGBOOK_APIS}
        >
          Save
        </Button>,
      ]}
      width={1000}
    >
      <div className="white-container">
        <h3 style={{ color: "red", textAlign: "center" }}>
          Missed Operation Details{" "}
        </h3>
        <br />
        <h3>Oil Record book Part 1 Information</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <SelectInput
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
                LIST_OIL_RECORD_ITEM_API(value);
              }}
              options={codeList}
              errors={errors?.code_category_id}
            />
          </div>
          <div className="col-6">
            <AppInput
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
              showInfo={code !== 30}
              infoMessage="Original Operation Date"
              // min={previous_log_date}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>
        </div>

        {code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "5px",
              marginBottom: "5px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {groupedOptions.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                {/* Main Label as Checkbox */}
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      {optionGroup?.options?.length > 1 ? (
                        ""
                      ) : (
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some(
                            (item) => item.id === optionGroup.value
                          )}
                          onChange={() =>
                            handleCheckboxChange(optionGroup.value)
                          }
                          id={`group-checkbox-${index}`}
                        />
                      )}
                      <label
                        className="form-check-label"
                        htmlFor={`group-checkbox-${index}`}
                      >
                        {typeof optionGroup.label === "string" ? (
                          <strong>{optionGroup.label}</strong>
                        ) : (
                          <strong>{optionGroup.label.props.children}</strong>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* Input Field for Main Label */}
                  <div className="col-6" style={{ marginLeft: "22px" }}>
                      {selectedItems.some(
                        (item) => item.id === optionGroup.value
                      ) && (
                        Number(optionGroup.value) === 112 ?  <>
                       <TextArea
                        required
                        maxLength={1000}
                        className={`form-control ${
                          errors?.specialInput ? "border border-danger" : ""
                        }`}
                        autoSize={{ minRows: 2 }}
                        placeholder="Always start the sentence in Item 13 with the total quantity discharged. Our system will only look at that first number for our records."
                        value={
                          selectedItems.find((item) => item.id === optionGroup.value)
                            ?.specialValue || ""
                        }
                        onChange={(e) =>
                          handleSpecialInputChange(optionGroup.value, e.target.value)
                        }
                      />
                      {errors?.specialInput && (
                        <p style={{ color: "red", marginTop: "4px" }}>
                          {errors.specialInput}
                        </p>
                      )}
                    </>:
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder={
                            typeof optionGroup.label === "string"
                              ? optionGroup.label
                              : optionGroup.label.props.children
                          }
                          value={
                            selectedItems.find(
                              (item) => item.id === optionGroup.value
                            )?.value || ""
                          }
                          onChange={(e) =>
                            handleInputChange(optionGroup.value, e.target.value)
                          }
                        />
                      )}
                    </div>
                  {/* Special Input - Only for 112 */}
                  {/* {Number(optionGroup.value) === 112 && (
                    <div className="col-6" style={{ marginBottom: 20 }}>
                      {selectedItems.some(
                        (item) => Number(item.id) === 112
                      ) && (
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 2 }}
                          placeholder="Discharged Volume"
                          value={
                            selectedItems.find(
                              (item) => Number(item.id) === 112
                            )?.dischargedvolume || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              112,
                              e.target.value,
                              "dischargedvolume"
                            )
                          }
                        />
                      )}
                    </div>
                  )} */}
                </div>

                {/* Sub-options */}
                {optionGroup.options && (
                  <div
                    className="ms-3"
                    style={{ marginLeft: "30px", padding: "10px" }}
                  >
                    {optionGroup.options.map((option) => (
                      <div
                        key={option.value}
                        className="row align-items-center mb-2"
                      >
                        {/* Left Side - Checkbox */}
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              checked={selectedItems.some(
                                (item) => item.id === option.value
                              )}
                              onChange={() =>
                                handleCheckboxChange(option.value)
                              }
                              id={`checkbox-${option.value}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>

                        {/* Right Side - Input Field */}
                        {/* <div className="col-6" style={{ padding: "5px" }}>
                          {selectedItems.some(
                            (item) => item.id === option.value
                          ) && (
                            <TextArea
                              required
                              maxLength={1000}
                              className="form-control"
                              autoSize={{ minRows: 2 }}
                              placeholder={option.label}
                              value={
                                selectedItems.find(
                                  (item) => item.id === option.value
                                )?.value || ""
                              }
                              onChange={(e) =>
                                handleInputChange(option.value, e.target.value)
                              }
                            />
                          )}
                        </div> */}

                        {/* Special case: two inputs only for id '111-3' and code '24' */}
                        {/* {option.value === "111-3" && (
                          <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some(
                              (item) => item.id === option.value
                            ) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 2 }}
                                placeholder={"Evaporation Volume"}
                                value={
                                  selectedItems.find(
                                    (item) => item.id === option.value
                                  )?.evaporationVolume || "" // <- new JSON key
                                }
                                onChange={
                                  (e) =>
                                    handleInputChange(
                                      option.value,
                                      e.target.value,
                                      "evaporationVolume"
                                    ) // <- pass key name
                                }
                              />
                            )}
                          </div>
                        )} */}
                        <div className="col-6" style={{ padding: "5px" }}>
  {selectedItems.some((item) => item.id === option.value) && (
    <>
      {/* Special case: only show this special input when id=111-3 & code=24 */}
      {option.value === "111-3" && code === 24 ? (
        <>
          <TextArea
            required
            maxLength={1000}
            className={`form-control ${
              errors?.specialInput ? "border border-danger" : ""
            }`}
            autoSize={{ minRows: 2 }}
            placeholder="Always start the sentence in Item 12.4 with the total quantity evaporated. Our system will only look at that first number for our records."
            value={
              selectedItems.find((item) => item.id === option.value)
                ?.specialValue || ""
            }
            onChange={(e) =>
              handleSpecialInputChange(option.value, e.target.value)
            }
          />
          {errors?.specialInput && (
            <p style={{ color: "red", marginTop: "4px" }}>
              {errors.specialInput}
            </p>
          )}
        </>
      ) : (
        <TextArea
          required
          maxLength={1000}
          className="form-control"
          autoSize={{ minRows: 2 }}
          placeholder={option.label}
          value={
            selectedItems.find((item) => item.id === option.value)?.value || ""
          }
          onChange={(e) => handleInputChange(option.value, e.target.value)}
        />
      )}

    </>
  )}
</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {errors.sub_detail_values && (
          <ShowInputError errorMessage={errors.sub_detail_values} />
        )}
        <div className="row" style={{ alignItems: "center" }}>
          <div className="col-6">
            <AppInput
              label="Name of operation incharge"
              placeholder="Name of operation incharge"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.operation_details}
              showInfo={code !== 30}
              infoMessage="Signatur of In-charge (or C/E if signed off)"
            />
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
              >
                <Button
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AddOliRecordLogPartOneModal;
